import React from "react";
import { X } from "lucide-react";

export const DeleteModelSimple = ({
  open,
  onDelete,
  onCancel,
  message,
  cancelText = "Cancel",
  deleteText = "Delete",
  loading = false,
}) => {
  if (!open) return null;

  return (
    <div
      style={{
        height: "100%",
        position: "fixed",
        width: "100%",
        zIndex: 2147483647,
        background: "transparent",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="gs-delete-flow-model"
        style={{
          maxWidth: "520px",

          padding: "18px",
          backgroundColor: "#fdfdfd",
          position: "fixed",
          width: "600px",
          top: "50%",
          left: "50%",
          display: "flex",
          flexDirection: "column",
          zIndex: 2147483647,
          border: "1px solid #ced4da",
          borderRadius: "10px",
          transition: "all 0.3s",
          transform: "translate(-50%, -50%)",
          boxShadow: "rgb(0 0 0 / 50%) 0px 0px 0px 100vw",
          height: "auto",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "20px",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              color: "#040404 ",
              paddingBottom: "10px",
              textAlign: "start",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              fontFamily: "Nunito",
              fontWeight: 600,
            }}
          >
            {message ||
              "Are you sure you want to delete this? Once deleted, it cannot be recovered."}
          </span>
          <span>
            <X
              style={{
                width: "24px",
                height: "24px",
                color: "#696969",
                cursor: "pointer",
                marginTop: "4px",
              }}
              onClick={onCancel}
            />
          </span>
        </span>

        <div style={{ gap: "20px", justifyContent: "center", display: "flex" }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              width: "230px",
              borderRadius: "16px",
              height: "60px",
              border: "2px solid #F15D18",
              fontSize: "22px",
              fontFamily: "Nunito",
              color: loading ? "#ccc" : "#F15D18",
              marginRight: "20px",
              background: "transparent",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onDelete}
            disabled={loading}
            style={{
              width: "230px",
              borderRadius: "8px",
              height: "60px",
              backgroundColor: loading ? "#ccc" : "#F15D18",
              fontSize: "22px",
              fontFamily: "Nunito",
              color: "#FFFFFF",
              border: "none",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Processing..." : deleteText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModelSimple;
